import { IconActionClose16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';
import * as styles from './CloseButton.css';

export interface ICloseButtonProps {
  onClick?(event: React.MouseEvent<HTMLButtonElement>): void;
}

export const CloseButton: React.VFC<ICloseButtonProps> = ({ onClick }) => {
  return (
    <button className={styles['button']} onClick={onClick} type="button" aria-label="Закрыть">
      <IconActionClose16 color="icon-secondary-default" />
    </button>
  );
};
